import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PlannedMusicianList.html?raw';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { OMtypes, OMclassnames } from "../../_loadingHelpers/OM";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { ToasterHelpers } from "../../../more/Helpers";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';

class OMplannedMusicianList extends compose(_WidgetBaseSP) {
	templateString: any = template;

    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<OMtypes.plannedMusician>>>;

    private btnReload: HTMLButtonElement;
    private evProjectID: string;

    private entitylist: Array<any>;

    private entityview: MdsLax<InstanceType<typeof GenericEntityView>>;
    private entityViewBtn: HTMLElement;

    private plannedMusicianEV: MdsLax<InstanceType<typeof GenericEntityView>>;

    private tableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["musicianName", "functionName", "subfunctionName", "contracttype", "status" ],
        "attributes": ["c_associate", "ref_functional_group.description", "ref_functional_sub_group.description", "ref_engagement.ref_musican_contract_md.ref_musican_contract_type.description", "ref_musican_planning_ev_project_status.description" ],
        "headings": [(this as any).translate("General_Label_Musician"), (this as any).translate("General_Label_FunctionalGroup"), (this as any).translate("General_Label_FunctionalSubGroup"), (this as any).translate("General_Label_ContractType") , (this as any).translate("General_Label_Status") ],
        bgColors: [null, "ref_functional_group.coloration", "ref_functional_sub_group.coloration", "ref_engagement.ref_musican_contract_md.ref_musican_contract_type.coloration", "ref_musican_planning_ev_project_status.coloration"],
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<OMtypes.plannedMusician>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;
        //cell.formattingHandled = true;
        let icon = null;
        switch (colName) {
            //case "musicianName":
            //    if (this._selectedEntities.indexOf(entity) != -1) {
            //        this.UiModder.domClass.add(cell.tableCellNode, "accentBG");
            //    }                
            //    break;
            //case "dutyType":
            //    if (entity.ref_vt_duty_type.coloration) {
            //        this.UiModder.domClass.add()
            //    }
            //    break;
            //case "functionName":
                    // ???
            //    return true;
            //    break;
            default:
                return false;
        }
    }
    private _emitHandle: any = null;
    private _onChange_StoreData() {
        let diffData = this.store.getDiffData();
        let completeList = this.store.getCurrentCompleteList();

        if (!this.table) {
            this.setupTable();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", diffData), 100);
    }
    

    getData() {
        return this.store.getCurrentCompleteList();
    }
    getDiffData() {
        let diffData = this.store.getDiffData();
        return diffData;
    }

    private setTmpMusiciansPlanning() {
        this.hourGlassStart(this);
        this.hideNode(this.entityViewBtn, false);

        if (this.entityview) this.entityview.destroy();

        this.entityview = new GenericEntityView();
        this.entityview.on("change", () => { this.loadData(this.evProjectID); });

        this.entityview.setup({
            entityClass: "ev_projects",
            entityId: this.evProjectID,
            label: "",
            contextName: "TmpMusiciansPlanning",
            destination: this.entityViewBtn,
            events: {
                onDataLoaded: () => { this.hourGlassEnd(this); }
            }
        });

    }

    private showMusicianPlanningView(row: StaticTable.StaticTableRow<OMtypes.plannedMusician>, rowGroup: StaticTable.StaticTableRowGroup<OMtypes.plannedMusician>) {
        this.hourGlassStart(this);
        let entity: OMtypes.plannedMusician = rowGroup.entity;

        if (this.plannedMusicianEV) this.plannedMusicianEV.destroy();

        this.plannedMusicianEV = new GenericEntityView();
        this.plannedMusicianEV.on("change", () => { this.loadData(this.evProjectID); });

        this.plannedMusicianEV.setup({
            entityClass: entity.Classname,
            entityId: entity.ID,
            label: entity.c_associate,
            destination: "dlg",
            events: {
                onDataLoaded: () => { this.hourGlassEnd(this); }
            }
        });
    }

    private _onClick_reloadData(evt: MouseEvent) {
        this.loadData(this.evProjectID);
    }

    loadData(evProjectID: string) {
        if (evProjectID) this.evProjectID = evProjectID;
        
        evProjectID = this.evProjectID;

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_ProjectWizard__GetPlannedMusiciansOfProject",
            {
                "evProjectID": evProjectID
            },
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError)            
        )
    }

    private _onLoadDataError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showToast({
            title: "error loading " + this.translate("General_Label_PlannedMusicians"),
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message
        });
    }

    private _onLoadDataResponse(response: Array<OMtypes.plannedMusician>) {
        this.StandbyStop();
        this.setup(response, this.evProjectID);
    }

    private setupTable(): void {

        this.tableContainer.innerHTML = null;
       

        this.table = new StaticTable();

        //if (this.hasUserRole("OrchestraEmployment_Edit")) this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
        this.table.setFormatter(lang.hitch(this, this.table_formatterFunction));

        //if (this.hasUserRole("PlannedMusician_Delete")) this.table.addDefaultRowActionButton("delete");//, lang.hitch(this, this._onRowDeleting));
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);
        //this.table.addCustomRowActionButton("SMS", lang.hitch(this, this._onClick_SendSMS), "fas fa-sms", 1, this.translate("General_Label_SendSMS"));
        //this.table.addDefaultRowActionButton("select");
        //this.table.on("select", lang.hitch(this, this._onSelect));
        //this.table.addCustomRowActionButton("select",
        //    lang.hitch(this, this._onClick_Select),
        //    "fas fa-plus-circle",
        //    1,
        //    this.translate("General_Label_Select"),
        //    lang.hitch(this, this._checkActionAvailability)
        //);

        this.table.addLineConfig(this.tableLayout);
        this.table.setCyAttribute("PlannedMusicianList");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);

        //if (this.hasFeature("EvProject/TmpMusiciansPlanning")) this.table.setRowClick(lang.hitch(this, this.showMusicianPlanningView))
        this.table.setRowClick(lang.hitch(this, this.showMusicianPlanningView));
    }  

    setup(data: Array<OMtypes.plannedMusician>, evProjectID: string) {
        this.store.setup(data, "ID");
        this.evProjectID = evProjectID;
        this.entitylist = data;
        this.setupTable();

        if (this.hasFeature("EvProject/TmpMusiciansPlanning")) this.setTmpMusiciansPlanning();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        //this.hideNode(this.sectionAddEntry, !this.hasUserRole("OrchestraEmployment_Create"));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OMplannedMusicianList);